<template>
  <Container class="container-sm-none">
    <Card class="card-shadow mt-15 mt-md-0">
      <div class="width-lg">
        <div class="pl-10 pl-md-0 pr-10 pr-md-0">
        <IconEmail />
        <p class="heading-2 heading-md-1 weight-medium mt-20">
          We're sorry but signing of your application was unsuccessful.
        </p>
        <p class="body-3 body-md-1 text-left weight-regular mt-10">
          We have emailed you your filled application along with instructions.
        </p>
        <p class="heading-3 mt-20">
          undefined
        </p>
        <Card class="card-border-gray-300 p-10 mt-10 b-rounded-12">
            <div class="flex gap-6 w-full">
                <CircleNumber :value="1" />
                <p class="body-3 mt-2 mb-0 text-left">
                  Please download, print, and sign your filled application.
                </p>
            </div>

            <div>
                <div class="flex gap-6 mt-10 w-full">
                    <CircleNumber :value="2" />
                    <p class="body-3 mt-2 mb-0 text-left">
                      Drop off your signed application together with a photocopy of your ID
                        <a class="color-primary" href="#">
                          at any of our Union branches
                        </a>
                      or post it to:
                      <i class="flex">Union zdravotná poisťovňa, a. s.</i>
                      <i class="flex">Karadžičova 10</i>
                      <i class="flex">814 53 Bratislava</i>
                    </p>
                </div>
                <InfoBox class="mt-10 ib-warning" :icon="require('@/assets/svg/alert-icon.svg')">
                    <p class="m-0 body-3 weight-regular">
                      In case of a change of insurance company, the signed application form must be sent by 30 September at the latest.
                    </p>
                </InfoBox>
            </div>
        </Card>
        <h3 class="mt-20">
          Thank you for choosing us.
        </h3>
        <div class="width-md mt-20">
          <InfoBox class="mt-5 ib-warning" :icon="require('@/assets/svg/alert-icon.svg')">
            <p class="m-0 pr-md-5 weight-regular body-3">
              You can close the browser window.
            </p>
          </InfoBox>
        </div>
    </div>
      </div>
    </Card>
  </Container>
</template>

<script>
import IconEmail from '@/components/Icons/IconEmail.vue';
import CircleNumber from '@/components/CircleNumber/CircleNumber.vue';
import Card from '@/components/Card/Card.vue';
import InfoBox from '@/components/InfoBox/InfoBox.vue';
import Container from '@/components/Container/Container.vue';
import enums from '../../mixins/enums';
import url from '../../mixins/url';
import GA from '../../mixins/GA';

export default {
  name: 'ESignatureFail',
  mixins: [enums, url, GA],
  components: {
    Container,
    IconEmail,
    CircleNumber,
    Card,
    InfoBox,
  },
  props: {
    model: { required: true, type: Object },
  },
  created() {
    this.$router.maxStep = 23;
    this.model.step = 23;
    if (this.model.lastStep < 23) this.model.lastStep = 23;

    this.esignFunnelError('ESIGN_FAIL', 'Esignature failed', 'Electronic signature failed in WNA application');
  },
};
</script>
